import React from "react";
import Image from "next/legacy/image";
import Link from "next/link";

import UnderstandTanya from "public/assets/tanya/understand-tanya.png";
import {
  TanyaBannerWrapper,
  TanyaBannerContainer,
  TanyaBannerDesc,
  TanyaBannerFeaturesContainer,
  TanyaBannerButton,
  TanyaBannerImageWrapper,
  TanyaBannerFeatureItem,
  TanyaBannerTitle,
  TanyaBannerTitleHighlight,
  TanyaBannerContentContainer
} from "./tanya-banner-block.styles";

const TanyaBannerBlock: React.FC = () => (
  <>
    <TanyaBannerWrapper>
      <TanyaBannerContainer>
        <TanyaBannerContentContainer>
          <TanyaBannerTitle>
            Ngerti materi dengan
            <TanyaBannerTitleHighlight>Tanya</TanyaBannerTitleHighlight>
          </TanyaBannerTitle>
          <TanyaBannerDesc>
            Cari soal Matematika, Fisika, Kimia dan tonton video pembahasan biar
            ngerti materinya.
          </TanyaBannerDesc>
          <TanyaBannerFeaturesContainer>
            <TanyaBannerFeatureItem>
              Matematika, Fisika dan Kimia
            </TanyaBannerFeatureItem>
            <TanyaBannerFeatureItem>
              SD (Kelas 5-6), SMP dan SMA
            </TanyaBannerFeatureItem>
            <TanyaBannerFeatureItem>
              300,000+ video pembahasan soal
            </TanyaBannerFeatureItem>
            <TanyaBannerFeatureItem>
              Semua video udah dicek kebenarannya
            </TanyaBannerFeatureItem>
          </TanyaBannerFeaturesContainer>
          <Link href="https://colearn.id/tanya#tanya-search-block" passHref>
            <TanyaBannerButton data-testid="tanya-sekarang-button">
              Tanya sekarang
            </TanyaBannerButton>
          </Link>
        </TanyaBannerContentContainer>
        <TanyaBannerImageWrapper>
          <Image
            src={UnderstandTanya}
            alt="Understand Tanya benefits"
            layout="responsive"
            width={566}
            height={598}
            objectFit="fill"
          />
        </TanyaBannerImageWrapper>
      </TanyaBannerContainer>
    </TanyaBannerWrapper>
  </>
);

export { TanyaBannerBlock };
export default TanyaBannerBlock;
